import {useState, useContexttext, useContext, useEffect } from 'react';
import Filtres from '../vitrines/filtres/Filtres';
import './mobile_navigation.css';
import { useNavigate } from 'react-router-dom';
import { Notifications } from './Notifications';
import { UserContext } from '../../AppContextProvider';
import settingsIcon from '../icons/settings.png';
import chatIcon from '../icons/chat_mobile.png';
import filtresIcons from '../icons/_filtres.png';
import aboutIcon from '../icons/about.png';
import colis_icon from './icons/colis_.png';
import money_icon from './icons/money_.png';
import {QrCustomerTicket, QrPackageTicket, QrPaymentTicket} from '../utils/QrCodeScan';
import QRScanner from '../utils/QrCodeScan';
import { useFetch } from '../api/FetchApiData';
import { TabList } from 'react-tabs';
import ChatBot from '../chatbot/ChatBot';
import { FaWhatsapp } from "react-icons/fa";

function ButtonConversations()
{
    /*
    const [UserState,setUserState] = useContext(UserContext);
    const [counter,setCounter] = useState(UserState.messages_counter);
    const [convUrl,setConvUrl] = useState('/conversations/');
    const navigator = useNavigate();
    const message_received = (data)=>{
        if(!!data.user_profile)
        {
            //setCounter(data['profile'].messages_counter);
            setUserState({...data.user_profile})
        }
    }
    
    useEffect(()=>{
        
        //WsNotifications.onMessage(message_received);
        if(UserState.is_staff)
        {
            let role = 'staff';
            setCounter(UserState.messages_counter);
            setConvUrl(`/conversations/${role}/all/`);
        }
        else
        {
            const rik_id = sessionStorage.getItem('rikinaze_id');
            setCounter(UserState.messages_counter);
            setConvUrl(`/conversation/${rik_id}/`);
        }

    },[UserState.auth])
    */
    return(
        <div className='btn-nav'>
            <FaWhatsapp onClick={() =>{window.open("https://wa.me/123456789", "_blank")}} size={40} style={{width:'100%'}} color="black" />
            {/*
                <img onClick={() =>{window.open("https://wa.me/123456789", "_blank")}} style={{width:'100%'}}  src={chatIcon}  alt="navigation"/>
            */
            }
           {/*(UserState.messages_counter>0) && <span id="notif" onClick={e=>{}}>
                {UserState.messages_counter}
            </span>*/}
        </div>
    );
    }

function ButtonQrPayment({close=()=>{}})
{
    const [btnsState,setBtnsState] = useState({client:{selected:true,bgColor:'white'},partner:{selected:false,bgColor:'lightgray'},page: <QrCustomerTicket close={close} />})
    const [UserState,setUserState] = useContext(UserContext);

    const onClickPage = (target)=>{
            if(target==='Client')
                {setBtnsState({client:{selected:true,bgColor:'white'},
                    partner:{selected:false,bgColor:'lightgray'},
                    page:<QrCustomerTicket close={close} />
                    });
                }
            else if(target==='Partner')
                setBtnsState({client:{selected:false,bgColor:'lightgray'},partner:{selected:false,bgColor:'white'},page:<QrPaymentTicket close={close} />})

    }


    return(
    <div className="back-screen" style={{position:'fixed',top:'0px',left:'0px'}}>
        <div style={{width:'95%',backgroundColor:'white',position:'relative',top:'100px',margin:'auto',paddingTop:'10px'}}>
            {(UserState.is_staff) && <div style={{display:'block',width:'100%',justifyContent:'center'}}>
                <input className='Qr-ChangePage' onMouseOver={e=>{}} type='button' onClick={e=>{onClickPage("Client")}}  value={'Client'} style={{height:'35px',width:'45%',backgroundColor:btnsState.client.bgColor,border:'1px solid lightgray'}}  />
                <input className='Qr-ChangePage' type='button' onClick={e=>{onClickPage("Partner")}} value={'Partenaire'} style={{height:'35px',width:'45%',backgroundColor:btnsState.partner.bgColor,border:'1px solid lightgray'}} />
            </div>}
            {btnsState.page}
        </div>    
    </div>)
}

function ButtonQrPackage({close=()=>{}})
{
   return(
    <div className="back-screen" style={{position:'fixed',top:'0px',left:'0px'}}>
        <div style={{width:'95%',backgroundColor:'white',position:'relative',top:'100px',margin:'auto',paddingTop:'10px'}}>
            <QrPackageTicket close={close} />
        </div>
    </div>
   ) 
}


function Footer() {

    const [scanner,setScanner] = useState({display:'none',data:null});
    const [notification,setNotification] = useState({text:"",color:'black',display:'none'});
    const fetchData = useFetch();

    const [FilterComponent,SetFilterComponent] = useState({
        display:false,
        componet: <div className='footer-pop-screen' style={{height:'100vh'}} onClick={()=>{}}>
                    <Filtres  />    
                </div>
    });
    const [UserState,setUserState] = useContext(UserContext);
    
    /*
    const navigator = useNavigate();

    const onScan = (data)=>{
        fetchData.PutData({qr_code:data},'user/payment/1/').then((result)=>{
            if(result.result)
            {
                setNotification({text:"Vous pouvez recupérer l'argent", color:'green', display:'block'});
                setTimeout(()=>{setNotification({text:"", color:'black', display:'none'})},10000);
            }
            else
            {
                setNotification({text:result.error, color:'orangered', display:'block'});
                setTimeout(()=>{setNotification({text:"", color:'black', display:'none'})},10000);
            }
        });
    }
    */

    const Btn_Payments = ()=>{
        if(UserState.is_staff || UserState.is_partner)
            return(
                <div className="btn-nav">
                    <img style={{width:'100%'}} onClick={e=>{setScanner({...scanner,display:'payments'})}}  src={money_icon}  alt="navigation"/>
                    {(UserState.global_payments_counter>0) && <span id="notif" onClick={e=>{}}>
                        {UserState.global_payments_counter}
                    </span>}
                </div>
            );
        else
            return(
        <div className="btn-nav">
            <img style={{width:'100%'}} onClick={e=>{}}  src={aboutIcon}  alt="navigation"/>
        </div>);
    }

    const Btn_Colis = ()=>{
        if(UserState.auth)
            return(
                <div className="btn-nav">
                    <img style={{width:'100%'}} onClick={e=>{setScanner({...scanner,display:'colis'})}}  src={colis_icon}  alt="navigation"/>
                </div>
            );
        else
            return(
            <div className="btn-nav">
                <img style={{width:'100%'}} onClick={e=>{}}  src={settingsIcon}  alt="navigation"/>
            </div>);
    }
    

  return (
    <div id='footer' style={{zIndex:20}}>
        <Btn_Colis />

        {
        <ButtonConversations />
        }
        <Btn_Payments />
        <Notifications />
        <div onClick={e=>{SetFilterComponent({...FilterComponent,display:!FilterComponent.display});}} className='btn-nav'>
            <img style={{width:'100%'}} src={filtresIcons}  alt="navigation"/>
        </div>
        {FilterComponent.display && FilterComponent.componet}
        {
          //scanner.display && <QRScanner notification={scanner.notification} close={()=>{setScanner({...scanner,display:false})}} onScan={(data)=>{console.log(data);onScan(data);}} />
        }   
        {(scanner.display==='payments') && <ButtonQrPayment close={()=>{setScanner({...scanner,display:'none'})}} />}
        {(scanner.display==='colis') && <ButtonQrPackage close={()=>{setScanner({...scanner,display:'none'})}} />} 
    </div>
  )
}

export default Footer;
